import React from 'react';
import Hero from '../components/Hero';
import Mission from '../components/Mission';
import Programs from '../components/Programs';
import Values from '../components/Values';
import DonateCTA from '../components/DonateCTA';
import Footer from '../components/Footer';

const HomePage = () => (
  <>
    <Hero />
    <Mission />
    <Programs />
    <Values />
    <DonateCTA />
    <Footer />
  </>
);

export default HomePage;
